import React from 'react';

import SingleNextButton from '../Atoms/SingleNextButton';
import InvalidFeedback from '../Atoms/InvalidFeedback';
import StepShell from '../StepComponents/StepShell';

import { setApp, getApp, setCoAppState, getCoAppState } from '../../index';

class StepCoApplicantCheck extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            coAppType: getApp('coApplicantType')
        }
    }

    coAppCheck(event) {
        var check = event.target.value;
        setApp('coAppRelation', check);
        if (check === 'No co-applicant') {
            var type = "none";
            var cApp = "no";
            setCoAppState('false');
            this.props.history.push('/loan-application/authorized-user');
        } else if (check === 'Joint and Spousal' || check === 'Joint and Non-Spousal' || check === 'Co-signer and Non-Spousal') {
            var type = check;
            var cApp = "yes";
            setCoAppState('true');
            this.props.history.push('/loan-application/co-applicant-info');
        }

        setApp('coApplicantType', type);
        setApp('coApplicant', cApp);
    }

    render() {
        //var curCoApp = getCoAppState();
        var rFirstName = getApp('fname');
        var firstName = rFirstName.charAt(0).toUpperCase() + rFirstName.slice(1);

        return (
            <StepShell stepID="StepCoApplicantCheck"
                friendlyText={`Thanks ${firstName}. Let’s discuss co-applicants.`}
                requestText="Read carefully and please choose one."
                progress="53.75%"
                backLink="/loan-application/work"
                progressLabel="Co-Applicant"
            >
                <form>                              
                    <div className="loanApp-checkbox-buttons" onChange={this.coAppCheck.bind(this)}>
                        <div className="co-app-desc">
                            <p>A <strong>Co-Applicant</strong> is a person who both assumes equal liability AND benefits from the proceeds of your new credit card.</p>

                            <p>You will also have the ability to add authorized users later in the application. Each authorized user will receive an individual card without assuming equal liability. </p>
                            <p>So, will you have a co-applicant?</p>
                        </div>

                        <CoAppTypeRadio value="No co-applicant" label="NO. I am applying by myself" />

                        <CoAppTypeRadio value="Joint and Spousal" label="YES. My spouse" />

                        <CoAppTypeRadio value="Joint and Non-Spousal" label="YES. A co-applicant who is NOT my spouse" />

                        <SingleNextButton nextBtnTxt="next" />
                    </div>
                </form>
                
            </StepShell>
        )
    }
}

class CoAppTypeRadio extends React.Component {
    render() {
        var theValue = this.props.value;
        var theID = theValue.replace('-', '_');
        return (
            <div className="loanApp-checkbox">
                <input type="radio" id={theID} name="coApplicantType" value={this.props.value}  className="loanApp-form-control" />
                 <InvalidFeedback feedback="invalid" />
                 <label htmlFor={theID}>{this.props.label}</label>
            </div>
        )
    }
}

export default StepCoApplicantCheck;